module.exports = __webpack_public_path__ + "img/four.8f89c0c6.png";